import React, { useEffect, useState } from "react";
import MaterialIcon from "../MaterialIcon";
import "./chat-pro.css";

// Chat avatars of the mobile Pro chat (proChatKit.ChatAvatar):
//   person  round photo, else pastel + initials; optional green online dot
//   self    My Space: round accent-soft tile with the chat_paste_go glyph
//   room    a room's own chat: rounded accent-soft tile with the room initials (or its photo)
//   group   a group inside a room: rounded chip tile with the group glyph
// `color` (a room's / group's backend theme colour) tints room and group tiles.

const PASTELS = ["#FFE2CC", "#DCEBFF", "#FFE7D6", "#E8E1FF", "#DDF3E8", "#FCE1EC", "#E1F2F7"];

export const pastelFor = (key = "") => {
  let h = 0;
  const s = String(key || "");
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PASTELS[h % PASTELS.length];
};

export const initialsOf = (name = "") =>
  String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

const hasPhoto = (src) =>
  typeof src === "string" &&
  src.trim() !== "" &&
  !/head\.svg$|profile\.png$|(^|\/)user\.png$/i.test(src.trim()) &&
  !/\/(null|undefined)$/.test(src.trim());

const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
const toRgb = (hex) => {
  if (!HEX.test(String(hex || ""))) return null;
  let h = String(hex).slice(1);
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const n = parseInt(h, 16);
  return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
};

export default function ChatAvatar({ kind = "person", name = "", src, size = 30, online = false, color, className = "", title }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const photo = hasPhoto(src) && !failed;
  const square = kind === "room" || kind === "group";
  const rgb = square ? toRgb(color) : null;
  const style = { width: size, height: size };
  if (kind === "person") style.backgroundColor = pastelFor(name);
  if (rgb) {
    style.backgroundColor = `rgba(${rgb}, 0.16)`;
    style.color = `rgb(${rgb})`;
  }
  const fontSize = size <= 32 ? 10 : size <= 36 ? 11 : size <= 48 ? 13 : 26;
  const iconSize = Math.round(size * 0.55);

  let inner = null;
  if (kind === "self") inner = <MaterialIcon icon="chat_paste_go" size={iconSize} />;
  else if (kind === "group") inner = <MaterialIcon icon="group" size={iconSize} />;
  else inner = <span className="kjc-avatar__initials" style={{ fontSize }}>{initialsOf(name) || "·"}</span>;

  return (
    <span
      className={`kjc-avatar kjc-avatar--${kind}${square ? " is-square" : ""}${size >= 64 ? " is-large" : ""} ${className}`.trim()}
      style={style}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      {inner}
      {photo && kind !== "self" && kind !== "group" ? (
        <img className="kjc-avatar__img" src={src} alt="" onError={() => setFailed(true)} draggable={false} />
      ) : null}
      {online ? <span className="kjc-avatar__online" /> : null}
    </span>
  );
}
